// extracted by mini-css-extract-plugin
export default {"wrapper":"n2-z","play":"o2-z"};